import { AutosuggestSource } from '@publishing-engine/domain/types/article';
import axiosInstance from 'src/api/client';

export type IAutosuggestItem = {
  termId: string;
  name: string;
  [key: string]: unknown;
};

export type IAutosuggestSearchMethod = (
  query: string,
  limit: number,
  level?: number
) => Promise<{ data: IAutosuggestItem[] }>;

const levelParam = (level?: number) =>
  level !== undefined ? `&level=${level}` : '';

export function fetchSpecialtySuggestions(
  specialty: string,
  limit: number,
  level?: number
) {
  return axiosInstance
    .get<{ data: any }>(
      `integrations/reviewer-expertise-suggestion/speciality?speciality=${specialty}&offset=0&limit=${limit}${levelParam(
        level
      )}`
    )
    .then(r => r.data);
}

export function fetchKeywordSuggestions(
  termId: string,
  limit: number,
  level?: number
) {
  return axiosInstance
    .get<{ data: any }>(
      `integrations/reviewer-expertise-suggestion/keywords?termId=${termId}&offset=0&limit=${limit}${levelParam(
        level
      )}`
    )
    .then(r => r.data);
}

export const autosuggestSourceSearchMethod: Record<
  Exclude<AutosuggestSource, 'freeText'>,
  IAutosuggestSearchMethod
> = {
  root: fetchSpecialtySuggestions,
  byTermId: fetchKeywordSuggestions
};
